<template>
  <div class="modal-select">
    <input v-model="term" class="form-control" :placeholder="place" :disabled="disabled" :id="id || `input${idModal}`"
           @focus="focusInput" @blur="blurInput" @keyup="searchInput" @keydown.enter.prevent="selEnter" @keydown.down="selProximo(0)" @keyup.esc.stop="sairInput">
    <div :id="idModal" class="modal-select-box shadow-sm" :class="{'show': show}">
      <div v-if="!options.length" class="p-3 small">A lista está vazia</div>
      <div class="modal-select-item border-bottom" tabindex="0" v-for="(item, index) in search" :id="`modalSelItem${index}`"
           @mousedown="selecionar(item)" @keyup.enter="selecionar(item)" @keydown.down="selProximo(index + 1)" @keydown.up="selProximo(index - 1)" @blur="blurInput">
        {{item.texto}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalSelect",
  props: ['placeholder', 'options', 'value', 'disabled', 'id'],
  data() {
    return {
      idModal: this.$helpers.ID(),
      term: '',
      place: '',
      valor: null,
      show: false,
      cancelBlur: false,
      valores: [],
      search: [],
    }
  },

  methods: {
    selecionar(item) {
      this.show = false;
      this.term = item.texto;
      this.valor = item;
      this.$emit('selected', item);
    },

    selEnter(evt) {
      if (this.term.length && this.search.length === 1) {
        evt.target.blur();
        this.selecionar(this.search[0]);
      }
    },

    selProximo(index) {
      this.cancelBlur = true;
      this.$helpers.focusElement(`modalSelItem${index}`);

      setTimeout(() => {
        this.cancelBlur = false;
      }, 100)
    },

    focusInput($evt) {
      this.cancelBlur = false;
      this.place = this.term;
      this.term = '';
      this.search = this.valores;

      // const modal = document.getElementById(this.id);
      //
      // if (modal) {
      //   const ref = $evt.target.getBoundingClientRect();
      //   modal.style.top = (ref.top + 41) + 'px';
      //   modal.style.width = (ref.width) + 'px';
      // }

      this.show = true;
    },

    blurInput() {
      if (this.cancelBlur) {
        return;
      }

      this.show = false;
      this.place = this.placeholder || 'Buscar item';
      this.term = this.valor ? this.valor.texto : '';
    },

    sairInput(evt) {
      evt.target.blur();
    },

    searchInput() {
      if (this.term.trim().length) {
        const term = this.term.trim().toLowerCase();
        this.search = this.valores.filter(opt => opt._texto.includes(term) || opt.texto.toLowerCase().includes(term));

      } else {
        this.search = this.valores;
      }
    },

    encontrarValor(val) {
      let opt = val ? this.options.find(opt => opt.id === val) : {};
      this.term = opt.texto || this.place;
      this.valor = opt.texto ? opt : null;
    }
  },

  mounted() {
    this.valores = this.options.map(opt => { return { ...opt, _texto: opt.texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()}});
    this.search = this.valores;
    this.place = this.placeholder || 'Buscar item';
    this.encontrarValor(this.value);
  },

  watch: {
    value: {
      deep: true,
      handler (val) {
        this.encontrarValor(val);
      }
    }
  }
}
</script>

<style scoped>
 .modal-select {
   position: relative;
 }
 .modal-select .form-control:focus {
   box-shadow: none;
 }
 .modal-select-box {
   position: absolute;
   left: 0;
   top: 39px;
   width: 100%;
   z-index: 1;
   max-height: 120px;
   overflow: auto;
   visibility: hidden;
   min-height: 40px;
   border-radius: 8px;
   border: 1px solid #c9cbca;
   background-color: #E4E8E7;
   color: #000000;
   padding: 6px;
 }
 .modal-select-box.show {
   visibility: visible;
 }
 .modal-select-item {
   padding: 6px 8px;
   font-size: 0.9rem;
   border-radius: 8px;
   cursor: pointer;
   font-weight: 400;
 }
 .modal-select-item:hover, .modal-select-item:focus {
   background-color: #51A0FE;
   color: #fff;
 }
</style>